module.exports = __webpack_public_path__ + "static/media/img_mobile_offer@3x.1e92f2a7.png";